import { Component, OnInit, Input } from '@angular/core';
import { ModalBaseComponent } from '../add-or-edit-org-modal/modal-base.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../data/data.service';
import { OrganizationDetail, OrganizationClassSection } from '../data/organization-detail';
import { Course } from '../data/course';
import { Class } from '../data/class';
import swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-add-or-edit-class-modal',
  templateUrl: './add-or-edit-class-modal.component.html',
  styleUrls: ['./add-or-edit-class-modal.component.css']
})
export class AddOrEditClassModalComponent extends ModalBaseComponent<OrganizationDetail> implements OnInit {

  constructor(modalService: NgbModal, dataService: DataService) { super(modalService, dataService); }

  @Input() parentOrganizationID: number;
  @Input() class: Class;

  newLoginCode: string;
  loginCodeTaken: boolean;
  defaultStartDate: string;
  defaultEndDate: string;

  static courses: Course[];
  selectableCourses: { Code: string; Description: string; }[];

  ngOnInit() {
    this.setDefaultDates();
    this.getCourses();
    this.initializeNewData();
    this.loginCodeTaken = false;
  }

  initializeNewData() {
    this.data = {
      ID: 0,
      Description: '',
      LoginCode: '',
      TypeCode: 'CS',
      TypeDescription: '',
      ParentOrganizationID: this.parentOrganizationID,
      Administrators: [],
      ClassSection: new OrganizationClassSection()
    };
    this.data.ClassSection.StartingOn = this.defaultStartDate;
    this.data.ClassSection.Ending = this.defaultEndDate;

    if (!this.class) {
      this.class = Class.getNew();
    }
  }

  saveNew() {
    this.isWaiting = true;
    this.dataService.createOrganization(this.data).subscribe(o => {
      if (o) {
        if (!this.data.ClassSection.StartingOn) {
          this.data.ClassSection.StartingOn = this.defaultStartDate;
        }
        this.dataService.createClass(o.ID, this.data.ClassSection.StartingOn, this.data.ClassSection.Ending, this.newLoginCode).subscribe(c => this.saveComplete(c))
      }
    })
    this.isWaiting = false;
  }

  setDefaultDates() {
    var today = new Date();
    var year = today.getFullYear();
    var month = today.getMonth();
    var day = today.getUTCDate();
    this.defaultStartDate = `${year}-${month + 1}-${day}`;
    this.defaultEndDate = `${year + 1}-${month + 1}-${day}`
  }

  saveEdit() {
    this.isWaiting = true;
    this.dataService.updateOrganization(this.data).subscribe(o => {
      if (o) {
        var theClass = new Class();
        theClass.ID = this.data.ClassSection.ClassID;
        theClass.LoginCode = this.newLoginCode;
        theClass.StartingOn = this.data.ClassSection.StartingOn;
        theClass.Ending = this.data.ClassSection.Ending;
        theClass.Teachers = this.class.Teachers;
        this.dataService.updateClass(theClass).subscribe(c => this.saveComplete(c))
      }
    })
  }

  saveComplete(result: any) {
    if (result === undefined) {
      this.newLoginCode = this.class.LoginCode;
      this.modal.close();
    }
    if (result) {
      this.class.LoginCode = this.newLoginCode;
      this.dataRefresh.next();
      this.modal.close();
      this.initializeNewData();
    }
    this.isWaiting = false;
  }

  isInputValid(): boolean {
    return this.data.Description && this.data.Description.length > 0 && !this.loginCodeTaken && !(this.loginCodeTaken === undefined);
  }

  getCourses() {
    if (!AddOrEditClassModalComponent.courses) {
      this.dataService.getCourses().subscribe(courses => {
        AddOrEditClassModalComponent.courses = Course.Sort(courses);
        this.getCoursesDone();
      });
    }
    else {
      this.getCoursesDone();
    }
  }

  getCoursesDone() {
    this.selectableCourses = [
      {
        Code: 'Default',
        Description: 'Select course'
      }
    ];
    this.selectableCourses = this.selectableCourses.concat(AddOrEditClassModalComponent.courses);
  }

  openForEdit(toEdit: OrganizationDetail) {
    this.modalHeader = "Edit Class";
    this.newLoginCode = this.class.LoginCode;
    this.loginCodeTaken = false;
    super.openForEdit(toEdit);
  }

  triggerCheckLoginCode(loginCode: string): void {
    this.loginCodeTaken = undefined;
    this.debounceCheckLoginCode(loginCode);
  }

  debounceCheckLoginCode = this.debounce((loginCode: string) => this.checkLoginCode(loginCode));

  checkLoginCode(loginCode: string): void {
    if (!loginCode) {
      this.loginCodeTaken = false;
      return;
    }
    this.dataService.getClassByLoginCode(loginCode).subscribe(c => {
      this.loginCodeTaken = (c != null && c.Description != null);
    });
  }

  debounce(func: (a: string) => void, timeout: number = 200): (a: any) => void {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    }
  }
}
